import type { HttpClient } from "../http";
import type { SkuDTO, CreateSkuDTO } from "../types";

export function skusResource(http: HttpClient) {
  return {
    list: () => http.get<SkuDTO[]>("/skus"),
    get: (id: number) => http.get<SkuDTO>(`/skus/${id}`),
    create: (body: SkuDTO | CreateSkuDTO) => http.post<SkuDTO>("/skus", body),
    update: (id: number, body: SkuDTO | CreateSkuDTO) => http.put<SkuDTO>(`/skus/${id}`, body),
    remove: (id: number) => http.del(`/skus/${id}`),
    delete: (id: number) => http.del(`/skus/${id}`),
    approve: (id: number) => http.post<SkuDTO>(`/skus/${id}/approve`, {}),
    reject: (id: number) => http.post<SkuDTO>(`/skus/${id}/reject`, {}),
    listByVendor: (vendorId: number) => http.get<SkuDTO[]>(`/skus/vendor/${vendorId}`),
    bulkUpsert: (skus: (SkuDTO | CreateSkuDTO)[]) =>
      http.post<{ created: number; updated: number }>("/skus/bulk", skus),
  };
}
